import { format } from 'date-fns';
import { PatientAvatar } from '../avatar/PatientAvatar';
import './DisplayPatientInfo.scss';

export interface DisplayInfoProps {
  archived?: boolean;
  dateOfBirth?: string;
  familyName?: string;
  gender?: string;
  givenName?: string;
  medicalId?: string;
  middleName?: string;
  patientType?: string;
  profilePhotoString?: string;
}

export function DisplayPatientInfo({ archived, dateOfBirth, familyName, gender, givenName, medicalId, patientType, profilePhotoString, middleName }: DisplayInfoProps) {
  if (middleName && middleName !== '') {
    middleName = middleName.slice(0, 1) + '.';
  } else {
    middleName = '';
  }
  return (
    <div className="display-patient-info-container">
      <PatientAvatar profilePhotoString={profilePhotoString} />
      <div className="patient-info">
        <div className="column short">
          <div className="item strong">{givenName + ` ${middleName} ` + familyName} </div>
        </div>

        <div className="column">
          <div className="item">
            <div className="label-and-data">
              <div className="label">profile type:</div>
              <div className="data">{patientType ?? 'NONE'}</div>
            </div>
          </div>

          <div className="item">
            <div className="label-and-data">
              <div className="label">patient status:</div>
              <div className="data">{archived ? 'Archived' : 'Active'}</div>
            </div>
          </div>
        </div>

        <div className="column">
          <div className="item">
            <div className="label-and-data">
              <div className="label">gender:</div>
              <div className="data">{gender ?? 'N/A'}</div>
            </div>
          </div>

          <div className="item">
            <div className="label-and-data">
              <div className="label">date of birth:</div>
              <div className="data">{dateOfBirth ? format(new Date(dateOfBirth), 'dd-MMM-yyyy') : ''}</div>
            </div>
          </div>
        </div>

        <div className="column">
          <div className="item">
            <div className="label-and-data">
              <div className="label">medical ID:</div>
              <div className="data" style={{ textTransform: 'none' }}>
                {medicalId}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
